<template>
  <div class="cortex">
    <h1>{{ msg }}</h1>
    <button v-on:click="startTest">Start test</button>
    <button v-on:click="stopTest">Stop test</button>
  </div>
</template>

<script>
import Cortex from '../lib/cortex'

var client = null

// TODO here test logic
function rollingAverage (columns, windowSize) {
  let avgCount = 0
  const averages = {}
  return (row) => {
    avgCount = Math.min(windowSize, avgCount + 1)
    columns.forEach((col, i) => {
      const oldAvg = averages[col] || 0
      averages[col] = oldAvg + (row[i] - oldAvg) / avgCount
    })
    return averages
  }
}

function numbers (client, windowSize, onResult) {
  return client
    .createSession({status: 'open'})
    .then(client.subscribe({streams: [
      /*
      Channels
      mot Motion data from the accelerometer/gyroscope
      eeg Raw EEG data (see note in User accounts and licensing)
      com Mental Command Event
      fac Facial Expression Event
      met Performance Metrics data
      dev Device data include battery level , signal strength, and signal quality all of channel headset
      pow Band Power data
      sys System event ( for set up training )
      */
      'met'
    ]}))
    .then(_subs => {
      console.log(_subs)
      const subs = Object.assign({}, ..._subs)
      if (!subs.pow || !subs.mot || !subs.met || !subs.egg || !subs.fac || !subs.dev || !subs.sys) throw new Error('failed to subscribe')

      // Create a list of all the column indices relevant to each band
      // (there'll be one per sensor)
      const bands = {
        theta: [],
        alpha: [],
        betaL: [],
        betaH: [],
        gamma: []
      }
      for (let i = 0; i < subs.pow.cols.length; i++) {
        // pow columns look like: IED_AF3/alpha
        const bandName = subs.pow.cols[i].split('/')[1]
        bands[bandName].push(i)
      }
      const bandNames = Object.keys(bands)

      // Motion data columns look like 'IMD_GYROX', this will make them look like 'gyroX'
      const makeFriendlyCol = (col) =>
          col.replace(/^IMD_(.*?)([XYZ]?)$/, (_, name, dim) => name.toLowerCase() + dim)

      const motCols = subs.mot.cols.map(makeFriendlyCol)

      // Set up our rolling average functions
      // met always gets a window size of 1 because at the basic subscription
      // level it's averaged over 10s anyway
      const averageMet = rollingAverage(subs.met.cols, 1)
      const averageMot = rollingAverage(motCols, windowSize)
      const averageBands = rollingAverage(bandNames, windowSize)

      const data = {}
      for (const col of [...motCols, ...subs.met.cols, ...bandNames]) {
        data[col] = 0
      }

      const onMet = (ev) =>
        maybeUpdate('met', averageMet(ev.met))
      client.on('met', onMet)

      const onMot = (ev) =>
        maybeUpdate('mot', averageMot(ev.mot))
      client.on('mot', onMot)

      const onCom = (ev) =>
        maybeUpdate('com', ev.com)
      client.on('com', onCom)

      const current = {
        command: 'neutral',
        eyes: 'neutral',
        brows: 'neutral',
        mouth: 'neutral'
      }

      // Small wrapper function  to turn the column-oriented format we get from the
      // API into key:value pairs
      const columns2obj = (headers) => (cols) => {
        const obj = {}
        for (let i = 0; i < cols.length; i++) {
          obj[headers[i]] = cols[i]
        }
        return obj
      }
      const fac2obj = columns2obj(subs[1].fac.cols)
      const onFac = (ev) => {
        const data = fac2obj(ev.fac)

        let updated = false
        let update = (k, v) => {
          if (current[k] !== v) {
            updated = true
            current[k] = v
          }
        }

        // Eye direction doesn't have a power rating, so we send every change
        const threshold = 0
        update('eyes', data.eyeAct)
        if (data.uPow >= threshold) update('brows', data.uAct)
        if (data.lPow >= threshold) update('mouth', data.lAct)

        if (updated) onResult(Object.assign({}, current))
      }
      client.on('fac', onFac)

      // This averages overall the sensors in the pow stream to give us our
      // "bands" stream
      const averageSensors = (pow) =>
        bandNames.map((bandName) => {
          const sum =
            bands[bandName]
              .map(i => pow[i])
              .reduce((total, row) => total + row, 0)
          return sum / bands[bandName].length
        })

      const onPow = (ev) =>
        maybeUpdate('bands', averageBands(averageSensors(ev.pow)))
      client.on('pow', onPow)

      // Choosing whether to update here is a bit tricky - we want to update
      // at the rate of the fastest stream, but we don't know which one that
      // will be. So we just wait until we get a second update for the same
      // stream to send everything - that stream must be the fastest.
      let hasUpdate = {}
      const maybeUpdate = (key, newdata) => {
        if (hasUpdate[key]) {
          onResult(data)
          hasUpdate = {}
        }
        hasUpdate[key] = true
        Object.assign(data, newdata)
      }

      return () =>
        client
          .unsubscribe({streams: ['pow', 'mot', 'met']})
          .updateSession({status: 'close'})
          .then(() => {
            client.removeListener('mot', onMot)
            client.removeListener('pow', onPow)
          })
    })
}

export default {
  name: 'Cortex',
  data () {
    return {
      msg: 'Cortex API client test'
    }
  },
  methods: {
    startTest: function () {
      client = client || new Cortex({verbose: 3})
      const avgWindow = 10
      const auth = {
        username: 'insilico',
        password: 'emotivPass',
        // client_id: 'XfQ1sX8m03qTilfr68vn7FEpJyDnTl6yklJkfozp',
        // client_secret: 'GZvKlQAuuuotygVA0U3DbVDjoM6vd34Nz4i13grieeblM4GHG5tEfnTAzUfDT8e4tSosvgQ2qfkvJ1zGzucpkslXIMc8wcawNC4hS7TOOTipH9lx9qHreowN9tF5nxRD',
        debit: 1 // first time you run example debit should > 0
      }
      console.log(client);
      client.ready
        .then(() => {
          console.log('INIT is a: ' + typeof client.init + ' [ ' + JSON.stringify(client.init(auth) + ' ]'))
        })
        .then(() =>
          numbers(client, avgWindow, (averages) => {
            const output = Object.keys(averages)
              .map(k => `${k}: ${averages[k].toFixed(2)}`)
              .join(', ')

            console.log(output)
          })
        )

      // We could use the value returned by numbers) here, but when we ctrl+c it
      // will clean up the connection anyway
    },
    stopTest: function () {
      if (client && client !== null) {
        client.close()
        client = null
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// ExperimentCortex.vue?df618822